export const newUrlSystem = () => {
  const path = window.location.pathname;
  const [, rawOrgId] = path.split('/');
  const organizationId = parseInt(rawOrgId, 10);
  return !Number.isNaN(organizationId) && organizationId >= 0;
};

export const getUrlParamsFromWindow = () => {
  const path = window.location.pathname;
  const [, rawOrgId, , rawProjectId, , rawScheduleId] = path.split('/');
  const rawIds = [rawOrgId, rawProjectId, rawScheduleId];
  const ids = rawIds.filter((id) => id);
  return ids;
};
